/** 最小文字大小 */
export const MIN_FONT_SIZE = 12;
/** 最大文字大小 */
export const MAX_FONT_SIZE = 400;
